// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.A9UZy{display:flex;align-items:flex-start;gap:8px;margin-bottom:16px;white-space:normal}.JuLUC{padding:8px 16px}.Nkfob{display:flex;flex-direction:column;gap:8px}.Nkfob .A9UZy{margin-bottom:0}.nlyuP{display:flex;align-items:center;gap:8px;min-width:0}.EzkS_{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._XmzN{flex-shrink:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"missingFieldsWarning": `A9UZy`,
	"sheetContent": `JuLUC`,
	"mobileSummaryBody": `Nkfob`,
	"mobileSummaryLine": `nlyuP`,
	"mobileSummaryText": `EzkS_`,
	"mobileSummaryBadge": `_XmzN`
};
export default ___CSS_LOADER_EXPORT___;
